import React from 'react';
import { connect } from 'react-redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import PendingStatementsPage from './PendingStatementsPage';

const PendingStatementsSection = ({ bankId }) => <PendingStatementsPage bankId={bankId} />;

PendingStatementsSection.propTypes = {
  bankId: PropTypes.bankId
};

const mapStateToProps = state => ({
  bankId: selectors.bankId(state)
});

export default connect(mapStateToProps, null)(PendingStatementsSection);
